<script setup lang="ts">
import { useObjectTree } from '../model/model'
import './assets/style.scss'
import ObjectsTreeItem from './ObjectsTreeItem.vue'
import { useRoute } from 'vue-router'
import { watch, watchEffect } from 'vue'
import ObjectsTreeContext from './ObjectsTreeContext.vue'
import { useHelpers, useSseConnection } from '@/shared/lib'
import { useAuth } from '@/entities/Auth'

const tree = useObjectTree()
const route = useRoute()
const { findObjectToId } = useHelpers()
const auth = useAuth()

watchEffect(() => {
  tree.selectObjectId = Number(route.params.object_id) || 0
})

const { isLoading } = tree.load()

/**
 * Функция удаления элементов перетаскивания при
 * потере фокуса с дерева
 */
const mouseUpHandler = () => {
  tree.dragObjects = []
}

/* Устанавливаем SSE соединение */
const { handler } = useSseConnection((res: any) => {
  const item = findObjectToId(res.object_list_id, tree.objects)
  if (item) item.status = res.status
})

watch(
  () => auth.user,
  () => {
    if (auth.user && auth.user.object_group.id) {
      handler(`/tree/${auth.user.object_group.id}/statuses`)
    }
  },
  { immediate: true },
)
</script>

<template>
  <div class="v-tree" v-click-outside="tree.clearSelected" @mouseleave="mouseUpHandler">
    <div class="v-tree__loading" v-if="isLoading">
      <VProgressCircular color="white" indeterminate :size="30" :width="3" />
    </div>

    <template v-else>
      <ObjectsTreeItem v-for="item in tree.objects" :item="item" :key="item.id" />
    </template>

    <ObjectsTreeContext />
  </div>
</template>
